'use client';

import React from 'react';
import { Box, List, ListItem } from '@mui/material';
import Link from 'next/link';
import CustomImage from '@components/CustomImage';
import ParallaxText from '@components/ParallaxText';
import cn from './style.module.scss';

interface WharfSocialProps {
  images: {
    ransome_wharf_facebook?: { src: string };
    ransome_wharf_instagram?: { src: string };
    ransome_wharf_linkdin?: { src: string };
  };
}
export default function WharfSocial({ images }: WharfSocialProps) {
  return (
    <Box className={cn.wharfSocialWrapper}>
      {/* <List className={cn.wharfSocialList}>
        <ListItem>
          <Link className={cn.wharfSocialLink} href='#'>
            <CustomImage
              src={images.ransome_wharf_facebook?.src || ''}
              alt='Facebook'
              width={768}
              height={768}
            />
          </Link>
        </ListItem>

        <ListItem>
          <Link className={cn.wharfSocialLink} href='#'>
            <CustomImage
              src={images.ransome_wharf_instagram?.src || ''}
              alt='Instagram'
              width={768}
              height={768}
            />
          </Link>
        </ListItem>
        <ListItem>
          <Link className={cn.wharfSocialLink} href='#'>
            <CustomImage
              src={images.ransome_wharf_linkdin?.src || ''}
              alt='LinkedIn'
              width={768}
              height={768}
            />
          </Link>
        </ListItem>
      </List> */}
      <Box className={cn.WharfSocialCopyright}>
        <ParallaxText
          variant="p"
          animationType="slideInBottom"
          animationDuration={500}
        >
          &copy; {new Date().getFullYear()} London Square
        </ParallaxText>
      </Box>
    </Box>
  );
}
